// extracted by mini-css-extract-plugin
export default {"videoContainer":"House_videoContainer__B6DTP","videoInput":"House_videoInput__a3ALi"};